(function($, undefined) {
	'use strict';
	var utils;
	var headerUtils;
	var eventSignup;
	var hubspot;

	var init = function() {
		utils = Fw.component.models().utils;
		headerUtils = Fw.component.models().header;
		eventSignup = Fw.component.models().eventSignup;
		hubspot = Fw.component.models().hubspot;
		
		$('.add-to-cart-btn').on('click', onAddToCart);
		$('.promo-code-form__verify-availability-btn').on('click', onVerifyPromoCodeAvailabilityBtnClick);
		$('.promo-code-form__remove-code-btn').click(removePromoCode);
		$('.cart-popup').on('click', '.cart-popup-item__remove-btn', onRemoveCartItemBtnClick);
		$('.cart-popup__close-btn').on('click', onCartPopupCloseBtnClick);

		$(document).on('click', onDocumentClick);

		if ($('.cart-payment-popup').hasClass("cart-payment-popup_open-on-load")) {
			$('.cart-popup__pay-btn').trigger("click");
		}

		verifyCartIsUpToDate();
	};

	function onAddToCart() {
		var btn = $(this);
		btn.addClass('btn_disabled');

		var form = btn.closest(".add-to-cart-form");
		var processingContainer = btn.closest(".add-to-cart-container");
		var productId = $('[name=productId]', form).val();
		var quantity = $('[name=quantity]', form).val();
		var options = {};
		$('[name^=option]', form).each(function(i, el) {
			options[el.name] = el.value;
		});

		processingContainer.addClass("has-processing_active");
		addToCart(productId, quantity, (cartData) => {
			processingContainer.removeClass("has-processing_active");

			if (btn.hasClass("add-to-cart-btn_webconference")) {
				$(".add-to-cart-form").slideUp();
				$('.already-in-cart-ctn').slideDown();
			}
			setTimeout(function() {
				btn.removeClass('btn_disabled');
			}, 1000);
		}, 
		options, "", true);
	}

	function onVerifyPromoCodeAvailabilityBtnClick() {
		var btn = $(this);
		var form = btn.closest(".promo-code-form");
		var ctn = form.closest(".promo-code-form-container");
		var input = $('input[name=code]', form);

		updatePromoCode(input.val(), false, (response) => {
			input.val('');
		});
	}

	function onRemoveCartItemBtnClick() {
		var btn = $(this);
		var cartItem = btn.closest(".cart-popup-item");
		cartItem.addClass('has-processing_active');

		if (cartItem.attr('data-cart-id') === '0' && cartItem.attr('data-event-id').length > 0) {
			eventSignup.removeParticipant(cartItem.attr('data-event-id'), cartItem.attr('data-firstname'), cartItem.attr('data-lastname'));
		} else {
			removeFromCart(cartItem, () => {}, true);
		}
	}

	function onCartPopupCloseBtnClick() {
		$('.cart-popup').removeClass("visible");
	}

	// @options should be an object like so: 
	// {
	// 	option1: 23344-0,
	// 	option2: 34455-1,
	// 	...
	// }
	function addToCart (productId, quantity, callback = () => {}, options = {}, data = "", getCart = false, override = true, eventId = -1) {
		if (productId && quantity) {
			var params = {
				productId: productId,
				quantity: quantity,
				data: data,
				ajax: true
			};
			if (override) {
				params.override = true;
			}
			if (Object.keys(options).length > 0) {
				for (var i in Object.keys(options)) {
					var key = Object.keys(options)[i];
					params[key] = options[key];
				}
			}
            if (eventId !== -1) {
				params.eventId = eventId;
			}

			$.ajax({
				url: "/action/shopAddCart",
				method: "POST",
				data: params,
    			cache: false, 
				complete: function(response) {
                    let cartItemId = "";
                    let hsProductId = "";
                    try {
                        // success :-44814:823602323\r\n
                        cartItemId = response.responseText.split(":")[1].trim();
                        hsProductId = response.responseText.split(":")[2].trim();
                    } catch (e) {
                    }
                    getCartAjax(function(cartData) {
                        let hsDealId = $("body").attr("data-hubspot-current-deal-id");
                        // Set the hubspot deal id from the shopping cart's cache
                        // This is done in a case when user is opening 2 seperate windows/tabs and adding products when the cart is not up to date
                        if (!hsDealId && cartData.data.cart.extraField) {
                            $("body").attr("data-hubspot-current-deal-id", cartData.data.cart.extraField);
                        }

                        // Update DOM elements
                        var _completeCallback = function(response) {
                            addMissingCartItems(response);
                            toggleCreditCardInputs(response);
                            enablePaymentBtn();
                            try {
                                enablePaymentDelivery(response.data.cart.events);
                            } catch (err) {
                            }
                            showCartPopup();
                            // Process hubspot deal
                            hubspot.createOrUpdateHubspotDeal(
                                hsProductId,
                                quantity,
                                cartItemId,
                                null,
                                (hubspotResponse) => {
                                    callback(response);
                                }
                            );
                        };
                        if (getCart) {
                            updateCartQuantityUI(calculateCartQuantity(cartData), override);
                            updateCartTotal(cartData);
                            updatePromoCodeUI(cartData);
                            _completeCallback(cartData);
                        } else {
                            updateCartQuantityUI(getTotalQuantity(quantity), override);
                            updateCartTotal(cartData);
                            _completeCallback(response);
                        }
                    });
                }
			});
		}
		else {
			callback("Error: missing parameters in addToCart function.");
		}
	}

	function enablePaymentBtn() {
		$('.cart-payment-popup__show-payment-btn').removeClass('btn_disabled');
	}

	function enablePaymentDelivery(events) {
        var enabled = false;
        if (events && events.length) {
            for (var i = 0; i < events.length; i++) {
                if (events[i].deliverable) {
                    enabled = true;
                    break;
                }
            }
        }
        var ctn = $('.payment-step.event-signup__step_shipping');
        if (enabled) {
            $('[name=sameAddress]', ctn).trigger('change');
            ctn.show();
        } else {
            $('.required', ctn).addClass('derequired').removeClass('required');
            ctn.hide();
        }
	}

	function removeFromCart(cartItem, callback = () => {}, getCart = false) {
		var cartId = cartItem.attr('data-cart-id');
		if (cartId) {
			var params = {
				productId: cartId,
				remove: true,
				ajax: true
			};
			if (getCart) {
				params.getCart = true;
			}
			$.ajax({
				url: "/action/shopAddCart",
				method: "POST",
				data: params,
    			cache: false, 
				complete: function(addCartResponse) {
					removeFromCartComplete(cartItem, addCartResponse, callback);
				}
			});
		}
		else {
			callback("Error: missing productId in removeFromCart function.");
		}
	}

	function removeFromCartComplete(cartItem, response, callback = () => {}, cartData) {
		var cartId = cartItem.attr('data-cart-id');
		var productId = cartItem.attr('data-product-id');
		var eventId = cartItem.attr('data-event-id');
		var hsProductId = cartItem.attr('data-hs-product-id');
        var hsLineItemId = cartItem.attr('data-hs-line-item-id');

		var _complete = function() {
			if (cartData) {
                updateCartQuantityUI(calculateCartQuantity(cartData), true);
            } else {
                updateCartQuantityUI(getTotalQuantity(-1), false); // TODO what if I have 15 items of this product Id and I remove it?
            }
            cartItem.removeClass('has-processing_active');
            enableAddToCartBtn(cartItem.attr('data-product-id'));
            if (cartId === '0' && cartItem.attr('data-event-id').length > 0) {
                removeItemFromCartUI($('.cart-popup-item[data-event-id=' + cartItem.attr('data-event-id') + '][data-firstname="'+cartItem.attr('data-firstname')+'"][data-lastname="'+cartItem.attr('data-lastname')+'"]'));
                removeItemFromCartUI($('.cart-payment-item[data-event-id=' + cartItem.attr('data-event-id') + '][data-firstname="'+cartItem.attr('data-firstname')+'"][data-lastname="'+cartItem.attr('data-lastname')+'"]'), 1, false);
            } else {
                if (eventId !== '') {
                    removeItemFromCartUI($('.cart-popup-item[data-cart-id=' + cartId + '][data-event-id=' + eventId + ']'));
                    removeItemFromCartUI($('.cart-payment-item[data-cart-id=' + cartId + '][data-event-id=' + eventId + ']'), 1, false);
                } else {
                    removeItemFromCartUI($('.cart-popup-item[data-cart-id=' + cartId + ']'));
                    removeItemFromCartUI($('.cart-payment-item[data-cart-id=' + cartId + ']'), 1, false);                    
                }
            }
            updateCartTotal(cartData);
            toggleCreditCardInputs(cartData);
            resetCoachingProduct(productId, eventId);
            enablePaymentDelivery(cartData.data.cart.events);
            callback(response.responseText);
		};
        
        var _hubspot = function() {
            let datacart = cartData.data.cart;
            if (!datacart || ((!datacart.events || !datacart.events.length) && (!datacart.products || !datacart.products.length))) {
                hubspot.cancelHubspotDeal($('body').attr("data-hubspot-current-deal-id"), _complete);
            } else {
                let qty = 0;
                try {
                    // To ensure that the line item won't be deleted in hubspot when a cart item is not removed completely, we find the remaining quantity in cart data
                    // Coaching items can have bound eventId
                    if (eventId !== '' && productId === '0') {
                        for (let i = 0; i < datacart.events.length; i++) {
                            let o = datacart.events[i];
                            if ((o.id.toString() === eventId || o.hsLineItemId === hsLineItemId) && o.signups) {
                                qty += o.signups.length;
                            }
                        }
                    } else {
                        for (let i = 0; i < datacart.products.length; i++) {
                            let o = datacart.products[i];
                            if (o.id.toString() === productId &&o.cartId.toString() === cartId || o.hsLineItemId === hsLineItemId) {
                                qty += !o.quantity ? 1 : parseInt(o.quantity);
                            }
                        }
                    }
                } catch (err) {
                    console.error(err);
                }
                hubspot.createOrUpdateHubspotDeal(hsProductId, qty, cartId, null, _complete);
            }
        };
        
        if (!cartData || !cartData.data) {
            getCartAjax(response => {
                cartData = response;
                _hubspot();
            });
        } else {
            _hubspot();
        }
	}

	function calculateCartQuantity(cartData) {
		var events = cartData.data.cart.events;
		var products = cartData.data.cart.products;
		var productsQuantity = products ? products
							.map((product) => product.quantity ? parseInt(product.quantity) : 1)
							.reduce((acc, currentValue) => acc + currentValue, 0) : 0;
		var eventsQuantity = events ? events
							.map((event) => event.signups ? parseInt(event.signups.length) : 1)
							.reduce((acc, currentValue) => acc + currentValue, 0) : 0;
		return productsQuantity + eventsQuantity;
	}

	function enableAddToCartBtn(productId, clearAll = false) {
		if (productId && $('.add-to-cart-form').find('input[name=productId][value='+productId+']').length > 0) {
			$('.add-to-cart-form').find('input[name=productId][value='+productId+']').closest('.add-to-cart-form').slideDown().prev('.already-in-cart-ctn').slideUp();
		} else if (clearAll) {
			$('.add-to-cart-form').slideDown();
			$('.already-in-cart-ctn').slideUp();
		}
	}

	function getTotalQuantity(quantities) {
		return typeof quantities !== "number" ? quantities.split(',').reduce((total, current) => total + parseInt(current), 0) : quantities;
	}

	function updateCartQuantityUI(quantity, overwrite = false) {
		var bullet = $('.cart-bullet');
		var qty = parseInt(bullet.first().text()) || 0;
		var newQty = overwrite ? quantity : qty + parseInt(quantity);

		bullet.toggleClass('cart-bullet_show', newQty > 0);
		bullet.text(newQty);
		$('.cart-recap .cart-recap__items-count:not(.cart-recap__items-count_confirmation)').text(newQty);
	}

	function updateCartTotal(cartData) {
		var _update = function(cartData) {
			var subtotal = utils.formatNumberToMoney(cartData.data.cart.subtotal);
			var total = utils.formatNumberToMoney(cartData.data.cart.total);

			if (subtotal) {
				$('.subtotal').text(subtotal);
				$('.cart-popup__total').text(subtotal);
				$('.cart-recap .cart-recap__price-value:not(.cart-recap__price-value_confirmation)').text(subtotal);
			}
			updateTax('tax1', utils.formatNumberToMoney(cartData.data.cart.tps), cartData.data.cart.taxName1, cartData.data.cart.taxNumber1);
			updateTax('tax2', utils.formatNumberToMoney(cartData.data.cart.tvq), cartData.data.cart.taxName2, cartData.data.cart.taxNumber2);
			if (total) {
				$('.total').text(total);
			}
		};

		if (cartData) {
			_update(cartData);
		} else {
			getCartAjax(function(cartData) {
				_update(cartData);
			});
		}
	}

	function updateTax(taxClass, amount, taxName, taxNumber) {
		if (amount) {
			$('.cart-payment-popup__amount-value.'+taxClass).text(amount).closest('.cart-payment-popup__amount-row').removeClass('cart-payment-popup__amount-row_hide');
			if (taxName) {
				var newName = taxName;
				if (taxNumber) {
					newName += ' (' + taxNumber + ')';
				}
				$('.'+taxClass+'-name').text(newName);
			}
		} else {
			$('.cart-payment-popup__amount-value.'+taxClass).closest('.cart-payment-popup__amount-row').addClass('cart-payment-popup__amount-row_hide');
		}
	}

	function resetCoachingProduct(id, eventId = '') {
        if(eventId !== ''){
            $('.cart-coaching-item[data-id="' + id +'"][data-eventid = "' + eventId + '"]').removeClass('cart-coaching-item_added');
        } else {
            $('.cart-coaching-item[data-id="' + id + '"]').removeClass('cart-coaching-item_added');
        }
	}

	/*
	cartData : {
			data: {
				cart: {
					events: [],
					products: [],
					subtotal,
					total,
					tps,
					tvq
				}
			},
			ok: true
		}
	 */
	function addMissingCartItems(cartData) {
		if (cartData) {
			cartData = typeof cartData == "string" ? JSON.parse(cartData) : cartData;
			var events = cartData.data.cart.events;
			var products = cartData.data.cart.products;

			var cartPopup = $('.cart-popup');
			var cartItems = $('.cart-popup-item', cartPopup);
			//var cartPaymentPopup = $('.cart-payment-popup__items:not(.cart-payment-popup__items_recap)');
			//var cartPaymentItems = $('.cart-payment-item', cartPaymentPopup);

			for (var e in events) {
				var cartDataItem = events[e];
				var eventId = cartDataItem.hasOwnProperty("cartId") ? cartDataItem.cartId : cartDataItem.id;
				var signups = cartDataItem.signups;
				if (signups && signups.length > 0) {
					for (var s in signups) {
						var eventSignupItem = signups[s];

						// hack to get proper name if name has accents.
						cartPopup.append('<div style="display:none;" class="js-get-signup-firstname"></div>');
						cartPopup.append('<div style="display:none;" class="js-get-signup-lastname"></div>');
						cartPopup.find('.js-get-signup-firstname').html(utils.decodeText(decodeURIComponent(eventSignupItem.firstName)));
						cartPopup.find('.js-get-signup-lastname').html(utils.decodeText(decodeURIComponent(eventSignupItem.lastName)));

						var currentCartSignupItem = cartItems.filter('[data-event-id="' + eventId + '"][data-firstname="' + cartPopup.find('.js-get-signup-firstname').html() + '"][data-lastname="' + cartPopup.find('.js-get-signup-lastname').html() + '"]');

						cartPopup.find('.js-get-signup-firstname').remove();
						cartPopup.find('.js-get-signup-lastname').remove();

						if (currentCartSignupItem.length === 0) {
							createAppendItem(eventSignupItem, 'cart-popup-item_template', $('.cart-popup__items', cartPopup), cartDataItem);
							createAppendItem(eventSignupItem, 'cart-payment-item_clone', $('.cart-payment-popup__items:not(.cart-payment-popup__items_recap)'), cartDataItem);
							createAppendItem(eventSignupItem, 'cart-payment-item_clone', $('.cart-payment-popup__items.cart-payment-popup__items_recap'), cartDataItem);
						}
					}
				}
			}
			for (var k in products) {
				var cartDataItem = products[k];
				var productId = cartDataItem.hasOwnProperty("cartId") ? cartDataItem.cartId : cartDataItem.id;
				var currentCartItem = cartItems.filter("[data-cart-id=" + productId + "]");
                if (currentCartItem.length === 0) {
					createAppendItem(cartDataItem, 'cart-popup-item_template', $('.cart-popup__items', cartPopup));
					createAppendItem(cartDataItem, 'cart-payment-item_clone', $('.cart-payment-popup__items:not(.cart-payment-popup__items_recap)'));
					createAppendItem(cartDataItem, 'cart-payment-item_clone', $('.cart-payment-popup__items.cart-payment-popup__items_recap'));
				}
			}
			if ($('.cart-popup-item:not(.cart-popup-item_template)', cartPopup).length > 0) {
				$('.cart-popup__empty', cartPopup).slideUp();
				$('.cart-popup__pay-btn').slideDown();
				$('.site-header__cart-btn-mobile-ctn').addClass('site-header__cart-btn-mobile-ctn_show');
			}
		}
	}

	function createAppendItem(data, itemToClone, container, eventData) {
		var clone = createCartPopupItem(data, itemToClone, eventData);
		clone.hide();
		container.append(clone);
		clone.slideDown();
	}

	function createCartPopupItem(cartItemData, templateItemClass, eventData) {
		var cartItemTemplate = $('.'+templateItemClass).clone(true);
		var price = cartItemData.price;
		var name = utils.decodeText(eventData ? eventData.name : cartItemData.name);
		var categoryName = utils.decodeText(eventData ? $('.event-cat-info[data-id="'+ eventData.categoryId +'"]').attr('data-name') : cartItemData.categoryName);
		var categoryId = eventData ? eventData.categoryId : cartItemData.categoryId;

		$('.price', cartItemTemplate).text(utils.formatNumberToMoney(price));
		$('.name', cartItemTemplate).html(name);
		$('.category', cartItemTemplate).html(categoryName);
		if (cartItemData.quantity > 1) {
			$('.quantity', cartItemTemplate).html(cartItemData.quantity).closest('.js-quantity-ctn').fadeIn();
		}
		cartItemTemplate.attr("data-product-id", cartItemData.id);
		cartItemTemplate.attr("data-cart-id", cartItemData.cartId ? cartItemData.cartId : cartItemData.id);
		cartItemTemplate.attr("data-category-id", categoryId);
        if (cartItemData.hsProductId) {
            cartItemTemplate.attr("data-hs-product-id", cartItemData.hsProductId);
        } else if (eventData && eventData.hsProductId) {
            cartItemTemplate.attr("data-hs-product-id", eventData.hsProductId);
        }
        if (cartItemData.hsLineItemId) {
            cartItemTemplate.attr("data-hs-line-item-id", cartItemData.hsLineItemId);
        } else if (eventData && eventData.hsLineItemId) {
            cartItemTemplate.attr("data-hs-line-item-id", eventData.hsLineItemId);
        }
		if (eventData) {
			cartItemTemplate.attr("data-event-id", cartItemData.eventId);
			$('.js-firstname', cartItemTemplate).html(cartItemData.firstName);
			$('.js-lastname', cartItemTemplate).html(cartItemData.lastName).closest('.participant-ctn').fadeIn();
			cartItemTemplate.attr("data-firstname", $('.js-firstname', cartItemTemplate).html());
			cartItemTemplate.attr("data-lastname", $('.js-lastname', cartItemTemplate).html());
		}
		if (cartItemData.extraData) {
			cartItemTemplate.attr("data-event-id", cartItemData.eventId);
			$('.js-lastname', cartItemTemplate).html(cartItemData.extraData).closest('.participant-ctn').fadeIn();
			cartItemTemplate.attr("data-lastname", $('.js-lastname', cartItemTemplate).html());
		}
		cartItemTemplate.removeClass(templateItemClass);

		return cartItemTemplate;
	}

	function showCartPopup() {
		$('.cart-popup').addClass("visible");
	}

	function removeItemFromCartUI(itemToRemove, quantityRemoved = 1) {
		var price = utils.priceTextToFloat($('.cart-popup-item__price', itemToRemove).text());
		itemToRemove.slideUp(function() {
			itemToRemove.remove();

			if ($('.cart-popup-item:not(.cart-popup-item_template)').length === 0) {
				$('.cart-popup__pay-btn').slideUp();
				$('.cart-popup__empty').slideDown();
				$('.site-header__cart-btn-mobile-ctn').removeClass('site-header__cart-btn-mobile-ctn_show');
			
				$('.cart-payment-popup').removeClass('cart-payment-popup_payment');
				$('.cart-payment-popup__payment').slideUp();
				$('.cart-payment-popup__show-payment-btn').addClass('btn_disabled');
			}
		});
	}

	function clearCartUI() {
		$('.cart-popup-item:not(.cart-popup-item_template)').slideUp(function() {
			$(this).remove();
		});
		$('.cart-payment-item:not(.cart-payment-item_clone)').slideUp(function() {
			$(this).remove();
		});
		$('.cart-popup__pay-btn').slideUp();
		$('.cart-popup__empty').slideDown();
		$('.site-header__cart-btn-mobile-ctn').removeClass('site-header__cart-btn-mobile-ctn_show');
		$('.cart-coaching-item_added').removeClass('cart-coaching-item_added');
		$('.event-signup__participant:not(.event-signup__participant_clone)').slideUp(function() {
			$(this).remove();
			eventSignup.resetSignupBtnsState();
		});
		$('.cart-recap__person').addClass('cart-recap__person_hidden');
		clearPaymentCartUI();
		removeItemFromCartUI($('.cart-payment-popup__items cart-payment-item'), 1, false);
		updateCartQuantityUI(0, true);
		updateCartTotal();
		enableAddToCartBtn(null, true);
	}

	function clearPaymentCartUI() {
		$('.cart-payment-popup').removeClass('cart-payment-popup_payment visible');
		$('.cart-payment-popup__payment').slideUp();
		$('.cart-payment-popup__show-payment-btn').addClass('btn_disabled');
	}

	function clearCart(callback = () => {}, clearUI = false) {
		$.ajax({
			url: "/action/pmiSignup?clear=true",
			method: "post",
    		cache: false, 
			complete: function(response) {
				if (response.responseText.indexOf('success') !== -1 || response.statusText.toLowerCase().indexOf('ok') !== -1) {
					hubspot.cancelHubspotDeal($("body").attr("data-hubspot-current-deal-id"), function() {
						if (clearUI) {
							clearCartUI();
						}
						callback(response.responseText);
					});
				}
			}
		});
	}
	
	function getCartAjax(callback = () => {}, bypass = false) {
        let json = {};
		if (!bypass) {
			$.ajax({
				url: "/action/pmiSignup?ajax=true&cart=true",
				method: "get",
				dataType: "json",
    			cache: false,
                success: (resp, status, xhr) => {
                    if (typeof resp === 'string' && utils.isJson(resp)) {
                        json = JSON.parse(resp);
					} else if (typeof resp === 'object') {
                        json = resp;
                    }
                },
				complete: function(xhr, status) {
					callback(json);
				}
			});
		} else {
			callback(json);
		}
	}

	// Promo code utils
	function updatePromoCode (code, remove = false, callback = () => {}) {
		var params = {
			ajax: true,
			getPromoCodeStatus: true,
			code: code
		};
		if (remove) {
			params.delete = true;
		}

		var errorElement = null;
		var successElement = $('.form-message_promo-code-success');	
		successElement.slideUp(150);
		$.ajax({
			url: "/action/pmiApplyPromocode",
			method: "post",
			data: params,
    		cache: false, 
			complete: function(response) {
				if (response.responseText.indexOf("invalid") !== -1) {
					errorElement = $('.form-message_invalid-promo-code-error');
				} else if (response.responseText.indexOf("expired") !== -1) {
					errorElement = $('.form-message_expired-promo-code-error');
				} else if (response.responseText.indexOf("limit reached") !== -1) {
					errorElement = $('.form-message_limit-reached-promo-code-error');
				}
				else {
					getCartAjax(function(cartData) {
						updatePromoCodeUI(cartData);
						updateCartTotal(cartData);
						toggleCreditCardInputs(cartData);
						// if (cartData.data.cart.subtotal == 0) {
						// 	$('.event-signup__step_cc').hide();
						// 	$('.event-signup__step_no-cc').show();
						// }
						// else {
						// 	$('.event-signup__step_cc').show();
						// 	$('.event-signup__step_no-cc').hide();
						// }
					});
					if (!remove) {
						successElement.slideDown(300);
					}
					callback(response);
				}
				if (errorElement != null && errorElement.length > 0) {
					errorElement.slideDown(300);
					$('.js-toggle-promo-code').removeClass('promo-code-form__entered-code_hide');
					setTimeout(function() {
						errorElement.slideUp(150);
					}, 4000);
				}
			},
			error: function(jqxhr, status, error) {
				console.log(status + " " + error);
			}
		});
	}
	
	function updatePromoCodeUI(cartData) {
		if (cartData) {
			var cart = cartData.data.cart;
			if (cart.promoName) {
				$('.promo-code-form__remove-code-btn').attr('data-code', cart.promoName);
				$('.promo-code-form__remove-code-btn').show();
			} else {
				$('.promo-code-form__remove-code-btn').attr('data-code', '');
				$('.promo-code-form__remove-code-btn').hide();
			}

			if (cart.promoCode) {
				var promo = ''; 
				if (cart.promoCode === cart.promoName) {
					promo += 'Promo: ';
					promo += cart.promoName;
					promo += ' (';
					cart.promoCodeUnit === '$' ? promo += utils.formatNumberToMoney(cart.promoCodeValue) :  promo += (cart.promoCodeValue + cart.promoCodeUnit + ' - ' + utils.formatNumberToMoney(cart.promoValue));
					promo += ')';
				} else {
					promo = cart.promoCode
				}
				$('.js-promo-code-name').html(promo);
				$('.js-toggle-promo-code').removeClass('promo-code-form__entered-code_hide');
			} else {
				$('.js-toggle-promo-code').addClass('promo-code-form__entered-code_hide');
				$('.js-promo-code-name').html('');
			}
		}
	}
	
	function addPromoCode (code, callback = () => {}) {
		updatePromoCode(code, false, callback);
	}
	function removePromoCode (code, callback = () => {}) {
		var btn = $(this);
		updatePromoCode(btn.attr('data-code'), true, function() {
			btn.hide();
		});
	}

	function onDocumentClick(e) {
		var target = $(e.target);
		if ($('.cart-popup').hasClass("visible") && 
			!target.hasClass("cart-popup") && !target.closest(".cart-popup").length &&
			!target.hasClass("show-cart-btn") && !target.closest(".show-cart-btn").length) {
			$('.cart-popup').removeClass("visible");
		}
	}

	function resetStep(step) {
		step.find('.required').removeClass('required').addClass('derequired');
		step.find('.error').removeClass('error');
		step.find('.success').removeClass('success');
		step.removeClass('is-checked has-error');
		step.find('input').val('');
		step.find('.form-message').slideUp();
	}

	function toggleCreditCardInputs(cartData) {
		var _showCardInputs = function() {
			$('.cart-payment-popup').find('.event-signup__step_no-cc').hide(function() {
				resetStep($(this));
			});
			$('.cart-payment-popup').find('.event-signup__step_cc').show().find('.derequired').removeClass('derequired').addClass('required');
		};

		var _hideCardInputs = function() {
			$('.cart-payment-popup').find('.event-signup__step_cc').hide(function() {
				resetStep($(this));
			});
			$('.cart-payment-popup').find('.event-signup__step_no-cc').show().find('.derequired').removeClass('derequired').addClass('required');
		};

		if (cartData && cartData.data.cart.total) {
			var total = Number(cartData.data.cart.total.replace(',', '.')); 
			if (total > 0) {
				_showCardInputs();
			} else {
				_hideCardInputs();
			}
		} else {
			_showCardInputs();
		}
	}

	function verifyCartIsUpToDate(cartData) {
		var _onSuccess = function(cartData) {
			var events = cartData.data.cart.events;
			var products = cartData.data.cart.products;
			updateCartQuantityUI(calculateCartQuantity(cartData), true);
			addMissingCartItems(cartData);
			updateCartTotal(cartData);
			toggleCreditCardInputs(cartData);
			if ((products && products.length) || (events && events.length)) {
				enablePaymentBtn();
			}
            enablePaymentDelivery(events);
		};

		if (cartData) {
			_onSuccess(cartData);
		} else {
			getCartAjax((cartData) => {
				_onSuccess(cartData);
			});
		}
	}

	$(window).ready(init);

	Fw.component.export('cartUtils', {
		addToCart,
		clearCart,
		getCartAjax,
		verifyCartIsUpToDate,
		addPromoCode,
		removePromoCode,
		removeFromCart,
		removeFromCartComplete,
		updateCartTotal
	});
})(jQuery);